import { render, staticRenderFns } from "./AiGenerateHistoryDialog.vue?vue&type=template&id=8254cd0a&scoped=true&"
import script from "./AiGenerateHistoryDialog.vue?vue&type=script&lang=ts&"
export * from "./AiGenerateHistoryDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AiGenerateHistoryDialog.vue?vue&type=style&index=0&id=8254cd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8254cd0a",
  null
  
)

export default component.exports